import { useState, useEffect } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Module-singleton imperative confirm dialog (returns a Promise<boolean>).
let _resolver = null;
let _setState = null;

export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    _resolver = resolve;
    if (_setState) _setState({ open: true, ...opts });
    else resolve(window.confirm(opts.description || opts.title || "Potvrdit akci?"));
  });
}

export function ConfirmRoot() {
  const [state, setState] = useState({ open: false });
  useEffect(() => {
    _setState = setState;
    return () => { _setState = null; };
  }, []);

  const finish = (val) => {
    setState((s) => ({ ...s, open: false }));
    if (_resolver) { _resolver(val); _resolver = null; }
  };

  return (
    <AlertDialog open={state.open} onOpenChange={(o) => { if (!o) finish(false); }}>
      <AlertDialogContent className="bg-zinc-900 border-white/10 text-zinc-100" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-zinc-100">{state.title || "Potvrzení"}</AlertDialogTitle>
          {state.description ? (
            <AlertDialogDescription className="text-zinc-400">{state.description}</AlertDialogDescription>
          ) : (
            <AlertDialogDescription className="sr-only">Potvrďte prosím tuto akci.</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="bg-white/5 border-white/10 text-zinc-300 hover:bg-white/10 hover:text-white"
            onClick={() => finish(false)}
            data-testid="confirm-cancel"
          >
            {state.cancelText || "Zrušit"}
          </AlertDialogCancel>
          <AlertDialogAction
            className={state.danger
              ? "bg-red-500 text-white hover:bg-red-600"
              : "bg-indigo-500 text-white hover:bg-indigo-600"}
            onClick={() => finish(true)}
            data-testid="confirm-ok"
          >
            {state.confirmText || "Potvrdit"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmRoot;
